import { ActionIcon, Badge, Group } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { type ExtendedCustomColors } from "../../../../../mantine/mantine-additions";
import { InvoiceState, InvoiceType } from "../../../../../types/neWebApi.types";
import type { PPAInvoice, PPAInvoiceId } from "../../PPAInvoicePage.types";

const TYPE_LABELS: Record<InvoiceType, string> = {
  [InvoiceType.Invoice]: "Rechnung",
  [InvoiceType.Draft]: "Vorschau",
  [InvoiceType.Correction]: "Stornorechnung"
};

const TYPE_COLOURS: Record<InvoiceType, ExtendedCustomColors> = {
  [InvoiceType.Invoice]: "success",
  [InvoiceType.Draft]: "neutral",
  [InvoiceType.Correction]: "error"
};

export function getInvoiceTypeColumn(
  isLoadingDraft: (invoiceId: PPAInvoiceId) => boolean,
  onDownloadDraft: (invoiceId: PPAInvoiceId) => void
): MRT_ColumnDef<PPAInvoice> {
  return {
    id: "invoice_type",
    accessorFn: (row) => TYPE_LABELS[row.invoice_type],
    header: "Typ",
    enableGlobalFilter: false,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: Object.values(TYPE_LABELS)
    },
    Cell: ({ row }) => {
      const badgeColor =
        row.original.state === InvoiceState.corrected
          ? "error"
          : TYPE_COLOURS[row.original.invoice_type];

      return (
        <Group wrap="nowrap">
          <Badge color={badgeColor} radius="sm" variant="outline">
            {TYPE_LABELS[row.original.invoice_type]}
          </Badge>
          {row.original.invoice_type === InvoiceType.Draft && (
            <ActionIcon
              aria-label="Vorschau herunterladen"
              loading={isLoadingDraft(row.original.unique_identifier)}
              variant="transparent"
              onClick={() => onDownloadDraft(row.original.unique_identifier)}
            >
              <IconEye color="#333" />
            </ActionIcon>
          )}
        </Group>
      );
    }
  };
}
